export const firebaseConfig = {
  apiKey: "AIzaSyDpD8_GyreWvzv2p6L8U6ih933k0fUmHp0",
  authDomain: "jinro.app",
  databaseURL: "https://jinro-de8d7.firebaseio.com",
  projectId: "jinro-de8d7",
  storageBucket: "jinro-de8d7.appspot.com",
  messagingSenderId: "67065431238",
  appId: "1:67065431238:web:9fb1984dc6c6a66ac2c3c7",
  measurementId: "G-5NKPXDY80X",
};
